<template>
    <card :item="item" :type="type">
        <div class="cardbody color6" @click.stop="goDetails(item)">
            <div class="header">
                <div class="header-left">
                    <img  v-if="item.avatarAddress&&item.avatarAddress.includes('myhuaweicloud')"  style="object-fit:cover" :src="item.avatarAddress" alt />
                    <img v-else src="@/assets/public/gebilaowang.png" alt />
                </div>
                <div class="header-right">
                    <div class="header-title color3">
                        <div class="name single_hide">{{ item.name }}</div>
                        <div class="jian">{{ item.sex ? "女" : "男" }}{{ item.age ? ` | ${item.age}岁` : "" }}</div>
                        <div class="type" v-if="item.identity">已实名</div>
                        <div class="jian" v-if="item.isHealth == 1" style="margin-top:2px">
                            <img src="@/assets/worker/jian.png" alt="" title="健康证明" />
                        </div>
                        <div class="jian" v-if="item.fileName">
                            <img src="@/assets/worker/zi.png" alt="" title="资质证书" />
                        </div>
                    </div>
                    <div class="info">
                        <div>{{ item.nationName }}</div>
                        <div class="line" v-if="item.nationName">|</div>
                        <div>{{ item.workYear ? item.workYear + "年" : "--" }}</div>
                        <div class="line" v-if="item.workYear">|</div>
                        <div>{{ item.proficiencyName }}</div>
                        <div class="line" v-if="item.proficiencyName">|</div>
                        <div class="single_hide" style="min-width:200px;" :title="item.industryName">{{ item.industryName }}</div>
                    </div>
                </div>
            </div>
            <div class="content">
                <el-row :gutter="20">
                    <el-col :span="12" class="content-item single_hide">
                        <span class="color6">专业技术:</span>
                        <span :title="item.workTypeName" class="color3">{{item.workTypeName}}</span>
                    </el-col>
                    <el-col :span="12" class="content-item single_hide">
                        <span class="color6">工作区域:</span>
                        <span :title="item.workAreaName" style="max-height:200px" class="color3">{{item.workAreaName|formattingEngineering}}</span>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="address">
                  <img src="@/assets/team/locationIcon.png" alt="" />
                  <span style="margin-left: 5px" class="color6">{{ item.address ? item.address : "" }}</span>
                  <span v-if="item.updateTime===item.createTime" class="createTime color6">{{item.createTime | formatDate}}发布</span>
                  <span v-else class="createTime color6">{{item.updateTime | formatDate}}更新</span>
            </div>
    </card>
</template>
<script>
import {checkDataStatusMessage} from "@/utils/checkDataStatus";

export default {
    name: "cardWorkerList",
    components: {
        card: () => import("@/components/card/card")
    },
    inject:['cardListCom'],
    props: {
        item: Object,
        type: Number, // 1 工队 2 工程 3 工人 4 临时用工 5 工种报价 6劳务用工
        workerTYpe: {
            type: Number
        }
    },
    methods: {
        //跳转详细
        async goDetails({ no, industryNo, categoryNo }) {
          let type=await checkDataStatusMessage.call(this,this.type,no);
          if(type!=1){return;}
            let query = {
                no,
                industryNo,
                categoryNo
            }
            let routeUrlC = `${this.workerTYpe==1?"/teamListWorkerDetail":"/workerDetail"}?no=${no}`
            window.open(routeUrlC, "_blank")
            /*let path = this.workerTYpe === 1 ? "/teamListWorkerDetail": "/workerDetail"
            this.$router.push({path,query})*/
        }
    },
}
</script>
<style lang="scss" scoped>
.cardbody {
    padding: 10px;
    cursor: pointer;
    .header {
        display: flex;
        .header-left {
            width: 60px;
            height: 60px;
            border: 1px solid #e4e7ed;
            border-radius: 6px;
            margin-right: 20px;
            img {
                width: 100%;
                height: 100%;
                border-radius: 6px;
            }
        }
        .header-right {
            .header-title {
                display: flex;
                font-size: 16px;
                margin-bottom: 15px;
                .name {
                    max-width: 170px;
                    margin-right: 5px;
                }
                .type {
                    width: 54px;
                    height: 22px;
                    background: rgba(120, 192, 110, 0.1);
                    color: #78c06e;
                    font-size: 14px;
                    line-height: 22px;
                    text-align: center;
                    display: flex;
                    align-items: center;
                }
                .jian {
                    margin-left: 10px;
                    display: flex;
                    align-items: center;
                }
            }
            .info {
                display: flex;
                .line {
                    padding: 0 5px;
                }
            }
        }
    }
    .content {
        .content-item {
            margin-top: 7px;
        }
    }
}
.address {
    border-top: 1px dashed #e4e7ed;
    padding-left: 10px;
    height: 34px;
    line-height: 34px;
    position: relative;
    img {
        vertical-align: middle;
        margin-top: -4px;
    }
    .createTime{
        position: absolute;
        right: 15px;
    }
}
div {
    box-sizing: border-box;
}
.color6 {
    color: #666666;
}
.color3 {
    color: #333333;
}
.single_hide {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
